<ng-container *ngIf="post">
  <div class="header">
    <div class="content">
      <div class="contentInner">
        <div class="pageTitle" appReveal>
          <h1 class="headline">{{ post.title }}</h1>
          <p class="postDate"><time [attr.datetime]="post.datePublished">{{ post.displayDate }}</time></p>
        </div>
      </div>
    </div>
  </div>
  <nav class="breadcrumbs" aria-label="Breadcrumb">
    <div class="content">
      <div class="breadcrumbsInner">
        <ol>
          <li><a routerLink="/blog">Blog</a></li>
          <li aria-current="page">{{ post.title }}</li>
        </ol>
      </div>
    </div>
  </nav>
  <div class="content">
    <div class="contentInner">
      <article class="post">
        <app-illustration *ngIf="!post.heroImageThumbnailOnly"
                          class="heroImage"
                          [priority]="true"
                          [src]="post.heroImage.src"
                          [webpSrc]="post.heroImage.webpSrc"
                          [alt]="post.heroImage.alt"
                          [width]="post.heroImage.width"
                          [height]="post.heroImage.height"></app-illustration>

        <!-- Rendered at build time: the markup below is already in the prerendered HTML. -->
        <div class="postBody" (click)="onContentClick($event)">
          <ng-container *ngFor="let block of renderedBlocks">
            <div *ngIf="block.kind === 'html'" [innerHTML]="block.html"></div>
            <app-illustration *ngIf="block.kind === 'image'"
                              class="bodyImage"
                              [src]="block.image.src"
                              [webpSrc]="block.image.webpSrc"
                              [alt]="block.image.alt"
                              [width]="block.image.width"
                              [height]="block.image.height"></app-illustration>
          </ng-container>
        </div>
      </article>

      <p class="backToIndex"><a routerLink="/blog">&larr; All posts</a></p>
    </div>
  </div>
</ng-container>
